// extracted by mini-css-extract-plugin
export default {"general":"Menu_general__xn4fM","logo":"Menu_logo__U3ED-"};